<script lang="ts">
    import Container from "../../components/Container.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<!-- <LightTheme /> -->
<!-- <Hero headline="zuverlässig und <br>schnell" small /> -->
<Hero small />

<Container>
    <!-- <center> -->
    <Headline>
        {@html $t("page.management.headline")}
    </Headline>
    <Subline>
        {@html $t("page.management.subline")}
    </Subline>
    <p>
        {@html $t("page.management.p.1")}
    </p>
    <p>
        {@html $t("page.management.p.2")}
    </p>
    <p>
        {@html $t("page.management.p.3")}
    </p>
    <Gap />

    <Image
        src="https://liveicom.azureedge.net/sinus/img/members/Marcus_Landschof_Geschäftsführer_3G9A4542.jpg"
        rounded
    />
    <Gap />
    <strong>
        {@html $t("page.management.imagealt")}
    </strong>
    <!-- </center> -->
</Container>

<style lang="scss">
    @import "../../vars";
</style>
